var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.allowed)?_c(_vm.memberView,{tag:"component"}):_c('RequestStatus',{attrs:{"error":_vm.failed},on:{"retry":_vm.checkProject}})
}
var staticRenderFns = []

export { render, staticRenderFns }